import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { fields } from "../constants";
import { useCampaignDocumentDetails } from "./Promotions.hook";

export const AddEditNewPromotions = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editPromotions,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditPromotions,
  } = useCampaignDocumentDetails(query.get("editId") || "");

  const {
    data: promotionsById,
    isLoading: isLoadingPromotions,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditPromotions();
    }
  }, [query.get("editId"), query.get("id")]);

  const userFormConfig: FormConfig = {
    initialValues: {
      image: promotionsById?.payload?.image
        ? [
            {
              uid: "-1",
              name: "Promotions.png",
              status: "done",
              url: promotionsById?.payload?.image,
            },
          ]
        : editPromotions?.image
          ? [
              {
                uid: "-1",
                name: "Promotions.png",
                status: "done",
                url: editPromotions?.image,
              },
            ]
          : "",

      title: promotionsById
        ? decodeHTML(promotionsById.payload?.title)
        : editPromotions
          ? decodeHTML(editPromotions?.title)
          : "",
      field_common_malay_title: promotionsById
        ? decodeHTML(promotionsById.payload?.field_common_malay_title)
        : editPromotions
          ? decodeHTML(editPromotions?.field_common_malay_title)
          : "",
      field_common_mandarin_title: promotionsById
        ? decodeHTML(promotionsById.payload?.field_common_mandarin_title)
        : editPromotions
          ? decodeHTML(editPromotions?.field_common_mandarin_title)
          : "",
      body: promotionsById
        ? decodeHTML(promotionsById.payload?.body)
        : editPromotions
          ? decodeHTML(editPromotions?.body)
          : "",
      field_common_malay_description: promotionsById
        ? decodeHTML(promotionsById.payload?.field_common_malay_description)
        : editPromotions
          ? decodeHTML(editPromotions?.field_common_malay_description)
          : "",
      field_common_mandarin_descriptio: promotionsById
        ? decodeHTML(promotionsById.payload?.field_common_mandarin_descriptio)
        : editPromotions
          ? decodeHTML(editPromotions?.field_common_mandarin_descriptio)
          : "",
      field_terms_and_conditions: promotionsById
        ? decodeHTML(promotionsById.payload?.field_terms_and_conditions)
        : editPromotions
          ? decodeHTML(editPromotions?.field_terms_and_conditions)
          : "",
      field_malay_terms_and_conditions: promotionsById
        ? decodeHTML(promotionsById.payload?.field_malay_terms_and_conditions)
        : editPromotions
          ? decodeHTML(editPromotions?.field_malay_terms_and_conditions)
          : "",
      field_mandarin_terms_and_conditi: promotionsById
        ? decodeHTML(promotionsById.payload?.field_mandarin_terms_and_conditi)
        : editPromotions
          ? decodeHTML(editPromotions?.field_mandarin_terms_and_conditi)
          : "",
      field_end_date: promotionsById
        ? decodeHTML(promotionsById.payload?.field_end_date)
        : editPromotions
          ? decodeHTML(editPromotions?.field_end_date)
          : "",
      field_start_date: promotionsById
        ? decodeHTML(promotionsById.payload?.field_start_date)
        : editPromotions
          ? decodeHTML(editPromotions?.field_start_date)
          : "",

      published: promotionsById
        ? promotionsById.payload?.published?.toLowerCase() === "true"
        : editPromotions
          ? editPromotions?.published?.toLowerCase() === "true"
          : false,
    },
    fields: fields.campaign,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else {
          data[key] = ""; // fallback in case of invalid field
        }
      } catch (error) {
        console.error("Image processing failed for:", key, error);
      }
    }

    const formattedData = {
      ...data,
      ...(data.field_start_date && { field_start_date: data.field_start_date.replace("T", " ") }),
      ...(data.field_end_date && { field_end_date: data.field_end_date.replace("T", " ") }),
    };

    const payload = {
      action: action,
      method: method,
      module: "Advertisement",
      subModule: "campaign",
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...formattedData,
        id: editPromotions?.id || promotionsById?.payload?.id,
        published: String(data.published),
      },
      status: status,
    };

    console.log(payload, "payload");

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingPromotions}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Campaign`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingPromotions || drilldownLoading}
        config={userFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") ? `${eramanHost}/api/promotions/${editPromotions?.id || promotionsById?.payload?.id}` : `${eramanHost}/api/promotions/new`}`,
            `${query.get("editId") ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
